<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'CtaVousAvezDesQuestions'
});
</script>
<template>
  <ka-container
    code="cta-vous-avez-des-questions"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Container-Vous avez des questions ? -->
    <ka-container code="container-vous-avez-des-questions">
      <!-- Conteneur-textes-bouttons -->
      <ka-container
        code="conteneur-textes-bouttons"
        inner>
        <!-- Textes -->
        <ka-container code="textes">
          <ka-text code="titre">
            <span v-html="t('ctaVousAvezDesQuestions.containerVousAvezDesQuestions.conteneurTextesBouttons.textes.titre.value', `{0} `, [componentInstance.$titre.value])" />
          </ka-text>
          <ka-text code="texte">
            <span v-html="t('ctaVousAvezDesQuestions.containerVousAvezDesQuestions.conteneurTextesBouttons.textes.texte.value', `{0} `, [componentInstance.$description.value])" />
          </ka-text>
        </ka-container>
        <!-- Boutons -->
        <ka-container code="boutons">
          <ka-button
            code="prendre-rendez-vous"
            :options="{
              ripple: true,
              href: {
                name: `Contact`,
                hash: `#titre--p9`
              },
              click: componentInstance.prendreRendezVousClick
            }">
            <span v-html="t('ctaVousAvezDesQuestions.containerVousAvezDesQuestions.conteneurTextesBouttons.boutons.prendreRendezVous.value', `Contactez-nous`)" />
          </ka-button>
          <ka-button
            code="voir-la-faq"
            :options="{
              ripple: true,
              hidden: null
            }">
            <span v-html="t('ctaVousAvezDesQuestions.containerVousAvezDesQuestions.conteneurTextesBouttons.boutons.voirLaFAQ.value', `Voir la F.A.Q`)" />
          </ka-button>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { ctaVousAvezDesQuestionsComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c10')
const component = ctaVousAvezDesQuestionsComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  description?: Nullable<string>
  titre?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  description: 'Vous voulez parler plan de formation ? Vous avez des questions sur notre fonctionnement ? Vous avez du mal à définir précisément votre besoin ?',
  titre: 'Vous avez des questions ?',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:description',
  'update:titre'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    description: true,
    titre: true
  }
})
</script>
